import type { Hook } from '../types';

export function parseDataMetaInfo() {
  return {} as ReturnType<Hook['parseDataMetaInfo']>;
}

export default parseDataMetaInfo;
